import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/brand-theme.css";
import App from "@/App";
import { applyBrandCssVariables } from "@/brand";

// Inyecta variables CSS y el título inicial según BRAND_ID.
applyBrandCssVariables();

// 🧹 DESREGISTRAR Service Workers viejos (Jun 2026):
// Los SW antiguos tenían hardcoded `main.js` pero ahora CRA produce
// `main.<hash>.js` por código-splitting. Esto causaba que el SW
// sirviera HTML viejo en caché → pedía un main.js que ya no existe
// → app rota ("a veces carga, a veces no"). Mientras NO los rearmemos
// con estrategia robusta, mejor sin SW (la app funciona idéntico).
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => {
      r.unregister().catch(() => {});
    });
  }).catch(() => {});
  // Limpiar caches del SW por completo
  if (window.caches && caches.keys) {
    caches.keys().then((names) => {
      names.forEach((n) => caches.delete(n).catch(() => {}));
    }).catch(() => {});
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
